import {useState, type ChangeEvent, type ChangeEventHandler, type FormEventHandler} from 'react';
import type {SelectEventHandler} from 'types';

type useFormStateReturn<FormValues> = [
  FormValues,
  FormEventHandler & ChangeEventHandler & SelectEventHandler,
  Function
];

function useFormState<FormValues extends {}>(initialValues : FormValues) : useFormStateReturn<FormValues> {
  const [values, setValues] = useState(initialValues);

  const onChange = (event : ChangeEvent<HTMLInputElement>) => {
    const {value, name} = event.currentTarget || event.target;
    setValues(values => ({...values, [name]: value}));
  }
  
  const reset = () => setValues(initialValues);

  return [
    values,
    onChange,
    reset
  ];
}

export default useFormState;